import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { getRankAchievers, getRanks } from '../api';

/** Public ranks showcase list (config order). Empty while the feature is off. */
export function useRanks(enabled = true) {
  return useQuery({ queryKey: ['ranks'], queryFn: getRanks, enabled, retry: 0 });
}

/** Paginated achievers of one rank. Idle until a `code` is given. */
export function useRankAchievers(code: string | null) {
  return useInfiniteQuery({
    queryKey: ['ranks', code, 'achievers'],
    initialPageParam: undefined as string | undefined,
    queryFn: ({ pageParam }) => getRankAchievers({ code: code!, cursor: pageParam, limit: 24 }),
    getNextPageParam: (last) => last.nextCursor ?? undefined,
    enabled: !!code,
  });
}
